import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';

import { matchQuery } from './utils';

export const useSubscribeQuery = (filters, callback) => {
  const mountedRef = useRef(false);
  const queryClient = useQueryClient();
  const callbackRef = useRef(null);

  callbackRef.current = callback;
  useEffect(() => {
    mountedRef.current = true;
    const unsubscribe = queryClient
      .getQueryCache()
      .subscribe(({ query, type }) => {
        if (mountedRef.current) {
          if (type === 'queryUpdated' && matchQuery(filters, query)) {
            callbackRef.current(query);
          }
        }
      });

    return () => {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [queryClient, filters.queryKey]);
};
